module.exports = __webpack_public_path__ + "static/media/cartoes_selecao.1e13a521.svg";